import { Box, Button, IconButton, Typography, styled } from '@mui/material';

import { flexMixin } from 'utils/flexMixin';

import { titleTextColor } from 'assets/styles/_palette';

export const ModalContent = styled(Box)({
	...flexMixin({ direction: 'column', gap: 32 }),
	margin: '48px 0',
});

export const ModalTitle = styled(Typography)({
	fontSize: '24px',
	fontWeight: 700,
	lineHeight: '133.4%',
	color: titleTextColor,
});

export const ModalSubtitle = styled(Typography)({
	fontSize: '16px',
	fontWeight: 700,
	lineHeight: '157%',
	letterSpacing: '0.1px',
	color: titleTextColor,
});

export const ModalFiles = styled(Box)({
	...flexMixin({ justify: 'flex-start', align: 'flex-start', direction: 'column' }),
	width: '100%',
	maxHeight: '450px',
	overflowY: 'auto',
});

export const ModalFile = styled(Box)(() => ({
	...flexMixin({ justify: 'flex-start', gap: 16 }),
	width: '100%',
	padding: '9px 16px',
	boxSizing: 'border-box',
	borderTop: '1px solid rgb(231, 232, 236)',

	'&:last-of-type': {
		borderBottom: '1px solid rgb(231, 232, 236)',
	},
}));

export const ModalFileContent = styled(Box)({
	...flexMixin({ gap: 16 }),
	'& svg': {
		height: '24px',
		width: '24px',
	},
});

export const ModalFileDescription = styled(Box)({
	...flexMixin({ align: 'flex-start', direction: 'column', gap: 2 }),
	'& h3': {
		fontSize: '14px',
		fontStyle: 'normal',
		fontWeight: '400',
		lineHeight: '143%',
		letterSpacing: ' 0.15px',
		color: 'rgb(16, 33, 66)',
	},
	'& p': {
		fontSize: '14px',
		fontWeight: 400,
		lineHeight: '143%',
		letterSpacing: '0.15px',
	},
});

export const EmptyState = styled(Box)({
	...flexMixin({ justify: 'flex-start', direction: 'column' }),
	width: '450px',
	height: '100%',
	margin: '50px 0',
	textAlign: 'center',

	'& svg': {
		width: '48px',
		height: '48px',
	},

	'& h3': {
		fontSize: '20px',
		fontWeight: 700,
		lineHeight: '160%',
		letterSpacing: '0.15px',
		color: '#0E1B33',
		margin: '24px 0 8px 0',
	},

	'& p': {
		fontSize: '16px',
		fontWeight: 400,
		lineHeight: '150%',
		letterSpacing: '0.15px',
		color: '#0E1B33',
	},
});

export const LoaderBox = styled(Box)({
	...flexMixin({}),
	margin: '50px 0',
	height: '100%',
	width: '100%',
});

export const ModalButtons = styled(Box)({
	...flexMixin({ gap: 16 }),
	flexWrap: 'wrap-reverse',
	width: '100%',
	padding: '0 10px',
	boxSizing: 'border-box',
});

export const ConfirmButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	backgroundColor: 'rgb(71, 134, 255)',
	color: 'rgb(255, 255, 255)',

	'&:hover': {
		backgroundColor: 'rgb(108, 158, 255)',
	},

	'&.Mui-disabled': {
		background: 'rgb(181, 207, 255)',
		opacity: 0.6,
		color: 'rgb(255, 255, 255)',
	},
});

export const CancelButton = styled(Button)({
	height: '44px',
	width: '215px',
	borderRadius: '8px',
	textTransform: 'none',
	fontSize: '16px',
	fontWeight: '700',
	color: 'rgb(71, 134, 255)',
	border: '1px solid rgb(71, 134, 255)',

	'&:hover': {
		backgroundColor: 'rgb(218, 231, 255)',
		color: 'rgb(108, 158, 255)',
		border: '1px solid rgb(108, 158, 255)',
	},
});

export const Pagination = styled(Box)({
	...flexMixin({ gap: 10 }),
	maxWidth: '500px',
	width: '100%',
});

export const PaginationButton = styled(IconButton)({
	'&.Mui-disabled': {
		opacity: 0.5,
	},

	'& svg': {
		height: '25px',
		width: '25px',
	},
});
